import moment from 'moment';

const screen = 'only screen';
const breakpointXs = '0';
const breakpointSm = '576px';
const breakpointMd = '768px';
const breakpointLg = '992px';
const breakpointXl = '1200px';

export const mediaQueries = {
  xsOnly: `${screen} and (min-width:${breakpointXs}) and (max-width: calc(${breakpointSm} - 1px))`,
  smOnly: `${screen} and (min-width:${breakpointSm}) and (max-width: calc(${breakpointMd} - 1px))`,
  mdOnly: `${screen} and (min-width:${breakpointMd}) and (max-width: calc(${breakpointLg} - 1px))`,
  lgOnly: `${screen} and (min-width:${breakpointLg}) and (max-width: calc(${breakpointXl} - 1px))`,
  xlOnly: `${screen} and (min-width:${breakpointXl})`,

  xsUp: `${screen} and (min-width:${breakpointXs})`,
  smUp: `${screen} and (min-width:${breakpointSm})`,
  mdUp: `${screen} and (min-width:${breakpointMd})`,
  lgUp: `${screen} and (min-width:${breakpointLg})`,
  xlUp: `${screen} and (min-width:${breakpointXl})`,

  xsDown: `${screen} and (max-width:calc(${breakpointSm} - 1px))`,
  smDown: `${screen} and (max-width:calc(${breakpointMd} - 1px))`,
  mdDown: `${screen} and (max-width:calc(${breakpointLg} - 1px))`,
  lgDown: `${screen} and (max-width:calc(${breakpointXl} - 1px))`,
  xlDown: `${screen} and (min-width:${breakpointXs})`,

  landscape: `${screen} and (orientation: landscape)`,
  portrait: `${screen} and (orientation: portrait)`,

  mobile: `${screen} and (max-width:calc(${breakpointLg} - 1px))`,
  desktop: `${screen} and (min-width:${breakpointLg})`,
};

export const mediaQueryKeys = {
  xsOnly: 'xsOnly',
  smOnly: 'smOnly',
  mdOnly: 'mdOnly',
  lgOnly: 'lgOnly',
  xlOnly: 'xlOnly',
  xsUp: 'xsUp',
  smUp: 'smUp',
  mdUp: 'mdUp',
  lgUp: 'lgUp',
  xlUp: 'xlUp',
  xsDown: 'xsDown',
  smDown: 'smDown',
  mdDown: 'mdDown',
  lgDown: 'lgDown',
  xlDown: 'xlDown',
  landscape: 'landscape',
  portrait: 'portrait',
  mobile: 'mobile',
  desktop: 'desktop',
};

export const defaultSeasonalState = { id: 10, name: 'Florida' }; // TO-DO: default value for Caregivers, confirm if can be null?

export const newPatientDefaultFormData = {
  lastName: '',
  firstName: '',
  middleInitial: '',
  primaryPhone: '',
  emailAddress: '',
  ssn: '',
  patientNumber: '',
  driversLicense: '',
  passportNumber: '',
  address1: '',
  address2: '',
  city: '',
  seasonalResident: false,
  zipCode: '',
  dob: '',
  county: { id: null, name: 'Select County' },
  permanentResident: true,
  hasSsn: true,
  seasonalState: { id: null, name: 'Select State' },
  gender: { id: null, name: 'Select Gender' },
  patientWeight: '',
  weightUnit: { id: 1, name: 'lbs' },
  authorizedForMultipleCaregivers: false
};

export const newCaregiverDefaultFormData = {
  lastName: '',
  firstName: '',
  middleInitial: '',
  primaryPhone: '',
  emailAddress: '',
  ssn: '',
  caregiverId: '',
  driversLicense: '',
  passportNumber: '',
  address1: '',
  address2: '',
  city: '',
  seasonalResident: false,
  zipCode: '',
  dob: '',
  county: { id: null, name: 'Select County' },
  permanentResident: true,
  hasSsn: true,
  seasonalState: defaultSeasonalState,
  gender: { id: null, name: 'Select Gender' },
  institutional: false
};

export const SSN_EMPTY_MASK = '___-__-____';

export const DL_EMPTY_MASK = '____-___-__-___-_';

export const PHONE_NUMBER_EMPTY_MASK = '___-___-____';

export const urls = {
  standardizedConsentForm: 'https://flboardofmedicine.gov/forms/medical-marijuana-consent-form.pdf',
  instructionalGuide2pc: 'https://knowthefactsmmj.com/wp-content/uploads/_documents/Instructional_Guides/QP/Submit-Second-Physician-Concurrence-Request.pdf'
};

export const DEFAULT_NEW_CERTIFICATION_FORM_DATA = {
  conductedExamPerson: null,
  telehealth: null,
  useOutweighsHarm: null,
  physicalExamDate: null,
  pregnant: null,
  reviewedHistory: null,
  patientConsentLetter: null,
  confirmNoExistingPhysician: null,
  durationLengthDays: { id: null, name: 'Select Days' },
  certificationStartDate: moment().format('MM/DD/YYYY'),
  selectedQualifyingConditions: [
    { id: 1, name: 'qualifyingCondition-1', checked: false },
    { id: 2, name: 'qualifyingCondition-2', checked: false },
    { id: 3, name: 'qualifyingCondition-3', checked: false },
    { id: 4, name: 'qualifyingCondition-4', checked: false },
    { id: 5, name: 'qualifyingCondition-5', checked: false },
    { id: 6, name: 'qualifyingCondition-6', checked: false },
    { id: 7, name: 'qualifyingCondition-7', checked: false },
    { id: 8, name: 'qualifyingCondition-8', checked: false },
    { id: 9, name: 'qualifyingCondition-9', checked: false },
    { id: 10, name: 'qualifyingCondition-10', checked: false },
    { id: 11, name: 'qualifyingCondition-11', checked: false },
    { id: 12, name: 'qualifyingCondition-12', checked: false },
    { id: 13, name: 'qualifyingCondition-13', checked: false },
  ],
};

export const CERTIFICATION_DURATION_DEFAULT_VALUES = [
  { id: null, name: 'Select Days' },
  { id: 35, name: '35' },
  { id: 70, name: '70' },
  { id: 105, name: '105' },
  { id: 140, name: '140' },
  { id: 175, name: '175' },
  { id: 210, name: '210' },
];

export const ADVERSE_EVENT_INITIAL_VALUES = {
  adverseEvent: '',
  startDate: '',
  severity: { name: 'Select Severity', id: null },
  actionTaken: { name: 'Select Action Taken', id: null },
  finalOutCome: { name: 'Select Final Outcome', id: null },
  checkIfContinuing: false,
  stopDateOrContinuing: '',
  relationshipToMedicalMarijuana: { name: 'Select Relationship to Medical Marijuana', id: null },
  expected: { name: 'Select Expected', id: null },
  serious: { name: 'Select Serious', id: null },
  notes: ''
};

export const CONTROLLED_SUBSTANCES_INITIAL_VALUES = {
  substance: '',
  startingDose: '',
  currentDose: '',
  startDate: '',
  dateDiscontinued: ''
};

export const MINIMUM_PASSWORD_LENGTH = 12;

export const MAX_ORGANIZATION_LENGTH = 150;

export const maxPhotoSize = {
  text: '300 KB',
  bytes: 307181
};

export const maxPORSize = {
  text: '4MB',
  bytes: 4194310
};

export const maxSkcUploadSize = {
  text: '2MB',
  bytes: 2097152
};

export const MAX_LENGTH_893_CASE_NUMBER = 50;

export const MIN_MED_MARIJUANA_AGGREGATE = 24500;

export const SUSPENDED_CARDSTATUS_TEXT = 'Suspended';

export const CLIENT_ERROR_ID = 2;

export const MINIMUM_PHYSICAL_EXAMINATION_DATE = moment('07/01/2016', 'MM/DD/YYYY');

export const MINIMUM_SQL_DATE = moment('01/01/1753', 'MM/DD/YYYY');

export const QUALIFYING_DOC_MAX_SIZE = 2000000;

export const ADVERSE_EVENT_NOTE_SIZE = 500;

export const DEFAULT_TIMEOUT = 1800; // in case the API cannot return a value for this

export const DEFAULT_WARNING_TIMEOUT = 60; // in case the API cannot return a value for this

export const MAX_DRIVERS_LICENSE_NUMBER = 32;

export const OMMU_EMAIL_ADDRESS = 'MedicalMarijuanaUse@flhealth.gov';

export const OMMU_PHONE = '850-245-4657';

export const HOME_LINK_STYLE = '<style type="text/css"> a { color: #575c8a;  font-weight: bold;  } a:hover {  text-decoration: none; }  </style>';

export const MAINTENANCE_MODE_TEXT = 'The Medical Marijuana Use Registry is currently undergoing maintenance and you may not log in at this time. Please try again later.';

export const SMOKING_DECIMAL_LIMIT = 3;

export const ADDRESS_FIELD_LENGTH_LIMIT = 50;

export const EMAIL_ADDRESS_FIELD_LENGTH_LIMIT = 100;

export const CITY_FIELD_LENGTH_LIMIT = 50;

export const DECIMAL_DAYS_LIMIT = 1;

export const DASBOARD_REFRESH_MINUTES = 5;

export const OrderTypeCard = {
  smoking: 'Smoking',
  medical: 'Medical Marijuana',
  lowThc: 'Low THC'
};

export const DEFAULT_MAILING_ADDRESS = {
  address1: '',
  address2: '',
  city: '',
  state: { id: 10, name: 'Florida' },
  zip: '',
  flagInvalid: false,
  notes: ''
};

export const ENTERED_ADDRESS = 'Entered';

export const SUGGESTED_ADDRESS = 'Suggested';
